import { useEffect, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
import examActions from "../../Redux/exam/actions";
import authActions from "../../Redux/auth/actions";
import commonActions from "../../Redux/common/actions";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import ErrorStatePage from "../safeBrowserDownload/ErrorStatePage";
import { getErrorPageProps } from "../../utils/errorUtils";

export default function Index() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { test_engine_project } = useParams();
  const [searchParams] = useSearchParams();
  const [ssoError, setSsoError] = useState(null); // { type: 'unauthorized' | 'activeSessionRunning', message }

  const token = searchParams.get("token");

  useEffect(() => {
    const authenticate = async () => {
      sessionStorage.clear();
      localStorage.clear();
      dispatch({ type: commonActions.SET_BUTTON_LOADER, payload: false });
      Cookies.set("test_engine_project", test_engine_project, { expires: 7 });
      const encodedData = await handleEncodeJson({
        encodeJSON: {
          projectShortName: test_engine_project,
          token,
        },
      });
      dispatch({
        type: authActions.CANDIDATE_USER_SSO_LOGIN,
        payload: {
          data: encodedData,
          navigate,
          onUnauthorized: (message) => setSsoError({type: "unauthorized", message}),
          onActiveSessionRunning: (message) => setSsoError({type: "activeSessionRunning", message}),
          onBadRequest: (message) => setSsoError({type: "badRequest", message}),
        },
      });
    };

    authenticate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const errorProps = getErrorPageProps(
    ssoError?.type,
    ssoError?.message
  );

  if (errorProps) {
    return <ErrorStatePage {...errorProps} />;
  }

return null;
  return null;
}
